export default function FlightSegmentService() {
    'ngInject';

    Object.assign(this, {
        getSelectedGroup,
        selectGroup,
        isOutwardSegment,
        isReturnSegment,
        getOutwardSegment,
        getReturnSegment,
        getPreviousSegment,
        getNextSegment,
    });

    function getSelectedGroup(selectedFlights, segment) {
        const groups = segment.FlightGroups;
        const [defaultGroup] = groups;
        const key = segment.FlightSegmentId;
        const selectedGroupId = selectedFlights && selectedFlights[key];
        const selectedGroup = groups.find(({FlightGroupId}) => FlightGroupId === selectedGroupId);
        if (selectedGroupId && selectedGroup) {
            return selectedGroup;
        }
        selectGroup(selectedFlights, segment, defaultGroup);
        return defaultGroup;
    }

    function selectGroup(selectedFlights, segment, group) {
        if (!(segment && group)) {
            return;
        }
        selectedFlights[segment.FlightSegmentId] = group.FlightGroupId;
    }

    function isOutwardSegment(recommendation, segment) {
        return getOutwardSegment(recommendation) === segment;
    }

    function getOutwardSegment(recommendation) {
        return recommendation.FlightSegments[0];
    }

    function getReturnSegment(recommendation) {
        return recommendation.FlightSegments[recommendation.FlightSegments.length - 1];
    }

    function isReturnSegment(recommendation, segment) {
        return getReturnSegment(recommendation) === segment;
    }

    function getPreviousSegment(recommendation, segment) {
        const OFFSET_PREVIOUS = -1;
        return getSegmentSibling(recommendation, segment, OFFSET_PREVIOUS);
    }

    function getNextSegment(recommendation, segment) {
        const OFFSET_NEXT = 1;
        return getSegmentSibling(recommendation, segment, OFFSET_NEXT);
    }

    function getSegmentSibling(recommendation, segment, offset) {
        if (!segment) {
            return null;
        }
        const segments = recommendation.FlightSegments;
        const id = segment.FlightSegmentId;
        const currentSegment = segments.find(({FlightSegmentId}) => FlightSegmentId === id);
        if (!currentSegment) {
            return null;
        }
        const currentIndex = segments.indexOf(currentSegment);
        return segments[currentIndex + offset] || null;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-segment-service.js